import { request } from './api-client';
import type { AISecret } from './types';

export type { AISecret };

export async function getSecrets(): Promise<{ data: AISecret[] }> {
  return request('/ai/secrets');
}

export async function revealSecret(id: string): Promise<{ data: { id: string; value: string } }> {
  return request(`/ai/secrets/${id}/reveal`);
}

export async function createSecret(data: {
  id: string;
  category: string;
  name: string;
  value: string;
  description?: string;
  isSecret?: boolean;
}): Promise<{ data: { id: string } }> {
  return request('/ai/secrets', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function updateSecret(
  id: string,
  value: string
): Promise<{ data: { id: string; updatedAt: string } }> {
  return request(`/ai/secrets/${id}`, {
    method: 'PUT',
    body: JSON.stringify({ value }),
  });
}

export async function deleteSecret(id: string): Promise<{ data: { deleted: boolean } }> {
  return request(`/ai/secrets/${id}`, {
    method: 'DELETE',
  });
}
